import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {Slider, Switch} from "@mui/material";
import {alpha} from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    headerContainer: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: 'solid 2px',
        fontWeight: "lighter",
        borderRadius: 5,
        padding: 15,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        width: "100%",
    },
    athletePositionBoxContainer: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'space-evenly',
        alignItems: 'center',
        width: "100%",
        marginTop: theme.spacing(4),
    },
    difficultyContainer: {
        width: "100%",
        marginTop: theme.spacing(4),
    },
    mainFocusContainer: {
        width: "100%",
        marginTop: theme.spacing(4),
    },
    blurringContainer: {
        width: "100%",
        marginTop: theme.spacing(4),
    },
    headerText: {
        color: theme.palette.text.primary,
        fontWeight: "bold",
        fontSize: 20,
        textAlign: "center"
    },
    subtitleText: {
        color: theme.palette.text.secondary,
        fontWeight: "bold",
        fontSize: 16,
        textAlign: "center"
    },
    infoText: {
        color: theme.palette.text.secondary,
        fontWeight: "bold",
        fontSize: 16,
        textAlign: "center"
    },
    formColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: "100%",
        paddingLeft: theme.spacing(1),
    },
    blurringGroup: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    videoCutSlider: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 10
    },
    videoProgressSlider: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 10
    },
    blurringError: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.main,
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5
    },
    rowBlack: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: 'solid 2px',
        borderRadius: 5,

        color: theme.palette.common.white,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        marginTop: 10
    },
    row: {
        color: theme.palette.common.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        flexDirection: 'row'
    },
    formRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        width: "100%",
        marginBottom: theme.spacing(1)
    },
    techniqueColumn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    topRow: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'start',
        alignItems: 'start'
    },
    warningPanel: {
        color: theme.palette.error.main,
        fontWeight: "bold",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    infoPanel: {
        color: theme.palette.common.white,
        fontWeight: "bold",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    timeInfoText: {
        color: theme.palette.common.white,
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    redBox: {
        backgroundColor: "red",
        height: 60,
        width: 60,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 16,
        fontWeight: "bold",
        border: "solid black 3px",
        borderRadius: 20
    },
    blueBox: {
        backgroundColor: "blue",
        height: 60,
        width: 60,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 16,
        fontWeight: "bold",
        border: "solid black 3px",
        borderRadius: 20
    },
    infoIcon: {
        height: 25,
        width: 25,
        marginRight: 3
    },
    menuItemHeader: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.common.white,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        borderRadius: 5
    },
    controlIcon: {
        color: theme.palette.text.primary,
        width: 30,
        height: 30,
        cursor: "pointer"
    },
    fullScreenIcon: {
        color: theme.palette.common.white,
        width: 40,
        height: 40,
    },
    fullScreenContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    fullScreenButton: {
        backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    fullScreenDescription: {
        padding: 5,
        marginRight: 5,
        color: theme.palette.common.white,
        backgroundColor: alpha(theme.palette.common.black, 0.25)
    },
    videoCutButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    playPauseButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.common.white
    },
    playPauseIcon: {
        width: 50,
        height: 50,
        color: theme.palette.common.white
    },
    setButton: {
        fontSize: 12
    },
    fastForwardRewindIcon: {
        height: 40,
        width: 40
    },
    fastForwardRewindButton: {
        color: "yellow",
        padding: 0
    },
    digitalClockContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: "yellow"
    },
    digitalClock: {
        fontSize: 32,
        textAlign: "center",
        fontStyle: "normal",
        fontWeight: 400,
        fontFamily: "digitalCounterFont",
        color: "yellow",
        marginLeft: 15,
        marginRight: 15
    },
    digitalClockSmall: {
        fontSize: 20,
        textAlign: "center",
        fontStyle: "normal",
        fontWeight: 400,
        fontFamily: "digitalCounterFont",
        color: theme.palette.text.primary
    },
    progress: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    blur: {
        filter: "blur(2px)"
    },
    scoreOutOfRange: {
        backgroundColor: theme.palette.error.main,
        borderTop: "solid",
        borderBottom: "solid",
        borderWidth: 2,
        borderCollapse: "collapse"
    },
    scoreOutOfFence: {
        backgroundColor: theme.palette.warning.main,
        borderTop: "solid",
        borderBottom: "solid",
        borderWidth: 2,
        borderCollapse: "collapse"
    },
    tableSortLabel: {
        fontWeight: "bold",
        color: theme.palette.common.white
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    },
    activeDrawingIcon: {
        color: theme.palette.primary.main
    },
    defaultPlaybackRateContainer: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    highlightingSliderRoundScoreBlue: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        marginTop: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    highlightingSliderRoundScoreRed: {
        borderRadius: 50,
        height: 18,
        width: 18,
        fontSize: 11,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        marginTop: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    scoreTabLabelRed: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    scoreTabLabelBlue: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
}));

const AthleteSwitchLeftRed = withStyles({
    switchBase: {
        color: 'red',
        '&$checked': {
            color: 'blue',
        },
    },
    checked: {},
    track: {},
})(Switch);

const AthleteSwitchLeftBlue = withStyles({
    switchBase: {
        color: 'blue',
        '&$checked': {
            color: 'red',
        },
    },
    checked: {},
    track: {},
})(Switch);

const VideoCutSlider = withStyles((theme) => ({
    root: {
        height: 2
    },
    thumb: {
        height: 30,
        width: 5,
        backgroundColor: '#3F51B5'
    },
    active: {},
    valueLabel: {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
        color: theme.palette.common.black
    },
    track: {
        height: 5,
        backgroundColor: (props) => props.outofrange === 1 && theme.palette.error.main,
        color: theme.palette.common.white
    },
    rail: {
        height: 2,
        opacity: 0.5,
        color: theme.palette.common.white
    },
    mark: {
        color: "transparent"
    },
    markActive: {
        opacity: 0,
        backgroundColor: 'currentColor',
    },
}))(Slider);

export {
    useStyles,
    AthleteSwitchLeftRed,
    AthleteSwitchLeftBlue,
    VideoCutSlider
};
